import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "@/router";

// Keeps one React root across hot reloads in `wxt dev`. `import.meta.hot` is undefined in a
// production build, so it must be optional.
const elem = document.getElementById("root") as HTMLElement;
const root = import.meta.hot?.data.root ?? createRoot(elem);
if (import.meta.hot) import.meta.hot.data.root = root;
root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
